import { cn } from '@/utils/cn';
import './styles/skeleton.css';

function SkeletonParent({ className, children, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-c870 relative isolate overflow-hidden rounded-md', className)}
      {...props}
    >
      {children}
      <span aria-hidden data-slot="skeleton-glare" className="skeleton-glare-sweep" />
    </div>
  );
}

function SkeletonChild({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton-child"
      className={cn('bg-c300/3 rounded-[inherit]', className)}
      {...props}
    />
  );
}

export { SkeletonChild, SkeletonParent };
